(function () {

    "use strict";

    function changeLenguaje($translate, tmhDynamicLocale, $window, $rootScope, LANGUAGES, $mdDateLocale) {
        var that = this;

        that.set = set;
        that.setLanguageNavegador = setLanguageNavegador;
        that.getLanguagesDisponibles = getLanguagesDisponibles;
        that.getNameLanguageNavegador = getNameLanguageNavegador;

        function setLanguageNavegador() {
            var lenguage = $window.navigator.userLanguage || $window.navigator.language;
            that.set(lenguage);
        }

        function getNameLanguageNavegador() {
            var lenguage = $window.navigator.userLanguage || $window.navigator.language;
            
            var languagesDisponibles = getLanguagesDisponibles();

            var labelLanguage = 'LANGUAGES.' + LANGUAGES.predefinido;

            languagesDisponibles.forEach(function obtenerLiteralLanguage(value) {
                if (value.locales.indexOf(lenguage.toLowerCase()) !== -1) {
                    labelLanguage = value.language;
                }
            });
            
            return labelLanguage;
        }


        function set(langKey) {

            if (langKey) {
                console.log('changelanguage: ' + langKey);

             
                    $translate.use(langKey);
                    tmhDynamicLocale.set(langKey);
                    //changeWijmoLocale(langKey);
                    setMdDateLocale(langKey);            }
        }
        function setMdDateLocale(langKey) {

            var localeDate = moment.localeData(langKey);
            
            $mdDateLocale.months = localeDate._months;
            $mdDateLocale.shortMonths = localeDate._monthsShort;

            //Solución error de moment al traer los shortmonths en castellano
            if (langKey === 'es') {
                $mdDateLocale.shortMonths = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
            }
            $mdDateLocale.days = localeDate._weekdays;
            $mdDateLocale.shortDays = localeDate._weekdaysMin;
            $mdDateLocale.firstDayOfWeek = localeDate._week.dow;
            $mdDateLocale.weekNumberFormatter = function (weekNumber) {
                return 'Semana ' + weekNumber;
            };
            $mdDateLocale.msgCalendar = 'Calendario';
            $mdDateLocale.msgOpenCalendar = 'Abrir calendario';
            var longDateFormat = localeDate._longDateFormat.L;
            $mdDateLocale.formatDate = function (date) {
                return date ? moment(date).format(longDateFormat) : null;
            };

            $mdDateLocale.parseDate = function (dateString) {
                var m = moment(dateString, longDateFormat, true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
            $mdDateLocale.msgCalendar = $translate.instant('MSG_CALENDAR');
            $mdDateLocale.msgOpenCalendar = $translate.instant('MSG_OPEN_CALENDAR');
        }

        //function changeWijmoLocale(langkey) {

        //    var languagesDisponibles = getLanguagesDisponibles();
            
        //    var loadCultureWijmo = false;

        //    languagesDisponibles.forEach(function obtenerLocaleLanguage(value) {
        //        if (value.locales.indexOf(langkey.toLowerCase()) !== -1) {
        //            loadCultureWijmo = true;
        //        }
        //    });

        //    if (loadCultureWijmo) {
        //        $.ajax({
        //            url: 'vendors_ext/wijmo/culture/wijmo.culture.' + langkey + '.min.js',
        //            dataType: 'script',
        //            success: function () {
        //                wijmo.Control.invalidateAll(); // invalidate all controls to show new culture
        //            }
        //        });
        //    }
        //}

        function getLanguagesDisponibles() {
            var languages = LANGUAGES.languages;

            var languagesTraducidos = [];

            languages.forEach(function traducirLanguages(value)
            {
                languagesTraducidos.push({
                    language: 'LANGUAGES.' + value.language,
                    locales: value.locales,
                    locale: value.locale
                });
            });

            return languagesTraducidos;
        }

    }

    changeLenguaje.$inject = ["$translate", "tmhDynamicLocale", "$window", "$rootScope", "LANGUAGES", "$mdDateLocale"];

    angular.module("sphforms.translate").service("sphforms.changeLenguaje", changeLenguaje);

})();